import PosthogService from '~/services/posthog/PosthogService';

export interface IDashboardOpenShiftClickedPayload {
  shiftCount: number;
}

export function fireDashboardOpenShiftClicked(payload: IDashboardOpenShiftClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:dashboard:open_shift_clicked', {
    shift_count: payload.shiftCount,
  });
}
